import React from 'react';
import { ExploreButton } from './ExploreButton';
import styles from './Hero.module.scss';
import wesiteLogo from '../../../images/web.gif';
export function Hero() {
  return (
    <section className={styles.heroSection}>
      <div className={styles.heroContainer}>
        <img
          loading="lazy"
          src={wesiteLogo}
          className={styles.heroBackground}
          alt="Interactive stories background"
        />
        <div className={styles.contentWrapper}>
          <div className={styles.contentContainer}>
            <div className={styles.textContent}>
              <div className={styles.titleWrapper}>
                <div className={styles.playText}>Play</div>
                <div className={styles.mainTitle}>
                  troak - interactive stories
                </div>
              </div>
              <div className={styles.subtitle}>
                Interactive stories by the best writers
              </div>
              <ExploreButton />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
